export const ROW_ACTIONS = {
  EDITAR: "EDITAR",
  SUCURSALES: "SUCURSALES",
  TOGGLE_ESTADO: "TOGGLE_ESTADO",
};
